import auth from '../domains/auth/testing.const';
import authComponents from '../components/shared/Auth/testing.const';
import channel from '../domains/channel/utils/testing.const';
import common from '../domains/common/components/testing.const';
import contestCommon from '../domains/contest/domains/common/testing.const';
import contestCreate from '../domains/contest/domains/managev2/domains/common/testing.const';
import contestDetail from '../domains/contest/domains/detail/constants/testing.const';
import contestGamecenter from '../domains/contest/domains/gamecenter/testing.const';
import contestGameCommon from '../domains/contest/domains/game/domains/common/testing.const';
import contestLobby from '../domains/contest/domains/lobby/constants/testing.const';
import deposits from '../domains/payments/deposits/testing.const';
import designSystem from '../domains/design-system/testing.const';
import entrantsManager from '../domains/entrants-manager/testing.const';
import header from '../components/shared/Header/testing.const';
import invite from '../domains/contest/domains/invite/constants/testing.const';
import kyc from '../domains/kyc/testing.const';
import lobby from '../domains/contest/domains/lobby/testing.const';
import myAccount from '../domains/account/testing.const';
import myContests from '../domains/contest/domains/myContests/testing.const';
import paymentsComponents from '../domains/payments/components/testing.const';
import quickPicks from '../domains/contest/domains/quickPick/testing.const';
import user from '../domains/user/testing.const';
import withdrawal from '../domains/payments/withdrawal/testing.const';
import home from '../domains/home/testing.const';
import manageContest from '../domains/manage-contest/testing.const';
import marketplace from '../domains/marketplace/testing.const';
import invitesManager from '../domains/invites-manager/testing.const';
import commissioner from '../domains/commissioner/testing.const';
import table from '../domains/design-system/components/Table/testing.const';
import notifications from '../domains/notifications/testing.const';
import promotions from '../domains/promotions/testing.const';
import loyalty from '../domains/promotions/domains/gamification/testing.const';

export default {
  auth,
  channel,
  common,
  components: {
    lobby,
    shared: {
      auth: authComponents,
      header,
      table,
    },
  },
  contest: {
    common: contestCommon,
    create: contestCreate,
    game: {
      common: contestGameCommon,
    },
    gamecenter: contestGamecenter,
  },
  commissioner,
  contestDetail,
  contestLobby,
  designSystem,
  entrantsManager,
  manageContest,
  myAccount,
  notifications,
  invitesManager,
  marketplace,
  home,
  invite,
  kyc,
  loyalty,
  myContests,
  payments: {
    components: paymentsComponents,
    deposits,
    withdrawal,
  },
  promotions,
  quickPicks,
  user,
};
